/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Error_Shop_Field_Too_LongInputs */

const vi_error_shop_field_too_long = /** @type {(inputs: Error_Shop_Field_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tối đa ${i?.max} ký tự.`)
};

/**

* @param {Error_Shop_Field_Too_LongInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_field_too_long = /** @type {((inputs: Error_Shop_Field_Too_LongInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Field_Too_LongInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_field_too_long(inputs)
});